// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"718f5afc","990":"a35668a9"}[chunkId] + ".chunk.js";
};